import { Breadcrumb, Flex, Typography } from "antd";
import type { ReactNode } from "react";
import CopyUrlButton from "../copy-url-button";

export interface PageLayoutProps {
  title: ReactNode;
  description?: ReactNode;
  extra?: ReactNode;
  copyUrl?: string;
  copyUrlTooltip?: ReactNode;
  breadcrumb?: { items: Array<{ title: ReactNode; href?: string }> };
  children: ReactNode;
}

const PageLayout = ({
  title,
  description,
  extra,
  copyUrl,
  copyUrlTooltip,
  breadcrumb,
  children,
}: PageLayoutProps) => (
  <Flex vertical gap={16} style={{ width: "100%" }}>
    {breadcrumb?.items?.length ? (
      <Breadcrumb
        items={breadcrumb.items.map((item) => ({
          title: item.href ? <a href={item.href}>{item.title}</a> : item.title,
        }))}
      />
    ) : null}
    <Flex align="center" justify="space-between" gap={16} wrap>
      <Flex align="center" gap={8}>
        <Typography.Title level={3} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        {description}
      </Flex>
      {copyUrl || extra ? (
        <Flex align="center" gap={8} wrap>
          <CopyUrlButton url={copyUrl} tooltip={copyUrlTooltip} />
          {extra ? <div>{extra}</div> : null}
        </Flex>
      ) : null}
    </Flex>
    <div>{children}</div>
  </Flex>
);

export default PageLayout;
